import { Injectable } from '@angular/core';
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import * as config from '../shared/config/app.config';
import { BaseService } from '../shared/services/base.service';
import { ExcelDownloadService } from '../shared/services/excel-download.service';
import { SharedService } from '../shared/services/shared.service';

@Injectable({
  providedIn: 'root',
})
export class OrderHistoryService {
  tabId: number;
  tabFilters: any;
  product: any;
  orderhistoryParams: any;
  public productFilterRemove = new BehaviorSubject<boolean>(false);
  productFilterRemove$ = this.productFilterRemove.asObservable();
  public userData = new BehaviorSubject<any>(null);
  userData$ = this.userData.asObservable();

  public legacyOrdersData = new BehaviorSubject<any>(null);
  legacyOrdersData$ = this.legacyOrdersData.asObservable();

  public allOrders = new BehaviorSubject<any>(null);
  allOrders$ = this.allOrders.asObservable();

  public allLegacyOrders = new BehaviorSubject<any>(null);
  allLegacyOrders$ = this.allLegacyOrders.asObservable();

  public orderDetails = new BehaviorSubject<any>(null);
  orderDetails$ = this.orderDetails.asObservable();

  public addCartDetails = new BehaviorSubject<any>(null);
  addCartDetails$ = this.addCartDetails.asObservable();

  public deleteOrderItems = new BehaviorSubject<any>(false);
  deleteOrderItems$ = this.deleteOrderItems.asObservable();

  public orderCartItems = new BehaviorSubject<any>(false);
  orderCartItems$ = this.orderCartItems.asObservable();

  public createdOrderCart = new BehaviorSubject<any>(false);
  createdOrderCart$ = this.createdOrderCart.asObservable();

  public saveCartOrderSuccess = new BehaviorSubject<any>(false);
  saveCartOrderSuccess$ = this.saveCartOrderSuccess.asObservable();

  public invalidOrderCartName = new BehaviorSubject<any>(false);
  invalidOrderCartName$ = this.invalidOrderCartName.asObservable();

  public orderSaveCartName = new Subject<any>();

  public orderStatusData = new BehaviorSubject<any>(false);
  orderStatusData$ = this.orderStatusData.asObservable();

  //order approval related
  public orderApprovalData = new BehaviorSubject<any>(null);
  orderApprovalData$ = this.orderApprovalData.asObservable();

  public reorderAddCartDetails = new BehaviorSubject<any>(null);
  reorderAddCartDetails$ = this.reorderAddCartDetails.asObservable();

  public submitPedigree = new BehaviorSubject<any>(null);
  submitPedigree$ = this.submitPedigree.asObservable();

  constructor(
    public baseService: BaseService,
    public sharedService: SharedService,
    public excelService: ExcelDownloadService,
    private readonly globalMessage?: GlobalMessageService,
  ) { }

  public getOrderHistory(params, filters?) {
    this.baseService
      .get(`${config.GET_ORDER_HISTORY}${params.userId}/orders`, filters)
      .subscribe((res) => {
        this.userData.next(res);
      });
  }

  public getFile(filters): Observable<any> {
    return this.baseService.getPdf(
      `/my-account/invoicepdf`, filters
    );
  }

  getHistoricalFile(filters): Observable<any> {
    return this.baseService.getPdf(
      `/my-account/packingslip-pdf`, filters
    );
  }

  public getLegacyOrderHistory(params, locDetails, filters?,) {
    this.baseService
      // .get(`${config.GET_ORDER_HISTORY}${params.userId}/legacyOrders?b2bUnitUid=${JSON.parse(localStorage.getItem('accountId'))}`, filters)
      // .get(`${config.GET_ORDER_HISTORY}${params.userId}/legacyOrders?b2bUnitUid=${locDetails}`, filters)
      .get(!!locDetails ? `${config.GET_ORDER_HISTORY}${params.userId}/legacyOrders?b2bUnitUid=${locDetails}` :
        `${config.GET_ORDER_HISTORY}${params.userId}/legacyOrders`, filters)
      .subscribe((res) => {
        this.legacyOrdersData.next(res);
      });
  }

  public getAllOrders(params, filters) {
    this.baseService
      .get(`${config.GET_ORDER_HISTORY}${params.userId}/orders`, filters)
      .subscribe((res) => {
        this.allOrders.next(res);
      });
  }

  public getAllLegacyOrders(params, filters) {
    this.baseService
      .get(`${config.GET_ORDER_HISTORY}${params.userId}/legacyOrders?b2bUnitUid=${JSON.parse(localStorage.getItem('accountId'))}`, filters)
      .subscribe((res) => {
        this.allLegacyOrders.next(res);
      });
  }

  public getOrderDetails(userId, code) {
    // const url = '/orders/' + code;
    const url = `${config.GET_ORDER_HISTORY}${userId}/orders/${code}`;
    this.baseService.get(url).subscribe((res) => {
      if (res) {
        this.orderDetails.next(res);
      }
    });
  }
  public getLegacyOrderDetails(userId, code) {
    const url = `${config.GET_ORDER_HISTORY}${userId}/legacyOrders/${code}?b2bUnitUid=${JSON.parse(localStorage.getItem('accountId'))}`;
    this.baseService.get(url).subscribe((res) => {
      if (res) {
        this.orderDetails.next(res);
      }
    });
  }
  addToCart(userId, data, cartId): void {
    this.baseService
      .post(
        config.USER_ACCOUNT + userId + '/carts/' + cartId + '/bulk-add-to-cart',
        data
      )
      .subscribe((res) => {
        this.addCartDetails.next(res);
        this.orderCartItems.next(false);
      });
  }
  clearCart(childCartId, userId): void {
    this.baseService
      .delete(config.USER_ACCOUNT + userId + '/carts/' + childCartId)
      .subscribe((res) => {
        this.deleteOrderItems.next(true);
        this.orderCartItems.next(false);
      });
  }
  // cart API
  getCarts(userId): void {
    this.orderCartItems.next(false);
    if (userId) {
      this.baseService
        .get(
          config.USER_ACCOUNT +
          userId +
          '/carts?currentPage=0&fields=DEFAULT&pageSize=20&savedCartsOnly=false'
        )
        .subscribe((res) => {
          this.orderCartItems.next(res);
        });
    }
  }

  createCart(userId): void {
    this.baseService
      .post(config.USER_ACCOUNT + userId + '/carts?fields=DEFAULT', {})
      .subscribe((res) => {
        this.createdOrderCart.next(res);
      });
  }

  public downloadXls(data, name) {
    this.excelService.exportAsExcelFile(data, name, true);
  }

  public downloadPdf(params): void {
    this.baseService
      .getPdf(config.DOWNLOAD_INVOICE_CREDIT_PDF, { invoiceNumber: params })
      .subscribe((res) => {
        const file = new Blob([res], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      }, error => {
        this.globalMessage.add('Requested document is not available at this moment', GlobalMessageType.MSG_TYPE_ERROR);
      });
  }
  getInvoicepdf(params) {
    this.baseService
      .getPdf(config.DOWNLOAD_INVOICE_PDF, { invoiceNumber: params })
      .subscribe((res) => {
        const file = new Blob([res], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      }, error => {
        this.globalMessage.add('Requested document is not available at this moment', GlobalMessageType.MSG_TYPE_ERROR);
      });
  }

  saveCartOrderDetails(userName, code, cartName): void {
    this.orderSaveCartName.next(false);
    this.invalidOrderCartName.next(false);
    this.saveCartOrderSuccess.next(false);
    this.baseService
      .patch(
        config.USER_ACCOUNT +
        userName +
        '/orders/' +
        code +
        '/save?fields=DEFAULT&saveCartName=' +
        cartName,
        {}
      )
      .subscribe(
        (res) => {
          if (res) {
            this.orderSaveCartName.next(res);
            this.saveCartOrderSuccess.next(true);
          }
        },
        (err) => {
          this.invalidOrderCartName.next(err);
        }
      );
  }

  getSavedOrderName(): Observable<any> {
    return this.orderSaveCartName.asObservable();
  }

  public getOrderStatus(params): void {
    this.baseService
      .get(config.GET_PRACTICEORFACILITYTYPE, params)
      .subscribe((res) => {
        this.orderStatusData.next(res);
      });
  }

  //order approval related - blockedorders
  public getOrdersForApproval(params, filters?) {
    this.baseService
      .get(`${config.GET_ORDER_HISTORY}${params.userId}/blockedorders`, filters)
      .subscribe((res) => {
        this.orderApprovalData.next(res);
      });
  }

  //single approval/reject - NOT used
  public approveOrRejectOrder(params) {
    return this.baseService
      .patch(`${config.USER_ACCOUNT}${params.userId}/orders/${params.code}/approve/?approve=${params.approve}?comments=${params.comments}?fields=DEFAULT`,
        {}
      );
  }

  //Multiple approval or reject at a time (using this for single rejection as well)
  public approveOrRejectOrders(userId, requestObj) {
    return this.baseService
      .post(`${config.USER_ACCOUNT}${userId}/orders/approve?fields=DEFAULT`, requestObj);
  }

  public sendInvoicesViaMailOrFax(userId, requestObj) {
    return this.baseService
      .post(`${config.USER_ACCOUNT}${userId}/sendInvoice?fields=DEFAULT`, requestObj);
  }

  reorderAddToCart(userId, data, cartId): void {
    this.baseService
      .post(
        config.USER_ACCOUNT + userId + '/carts/' + cartId + '/addItems?fields=DEFAULT&updateQuantity=false',
        data
      )
      .subscribe((res) => {
        this.reorderAddCartDetails.next(res);
      });
  }

  requestPedigree(userId, param): Observable<any> {
    return this.baseService.post(config.USER_ACCOUNT + userId + '/requestPedigree', param);
  }


}
